import styled from "styled-components";
import { NavLink } from 'react-router-dom'

export const FooterContainer = styled.footer`
    position: fixed;
    bottom: 0;
    width: calc(100vw - 30px);
    height: 60px;
    background-color: ${({ theme }) => theme.colors.primary};
    color:  ${({ theme }) => theme.colors.secondary};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-inline: 15px;
    padding-bottom: 15px;
    z-index: 1;
    
    @media only screen and (min-width: 501px) {
        width: 500px;
        margin-inline: auto;
    }
`

export const StyledLink = styled(NavLink)`
    color: #fff;
    stroke: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    -webkit-tap-highlight-color: transparent;


    &.${props => props.activeclassname} {
    color: ${({ theme }) => theme.colors.link.text};
    stroke: ${({ theme }) => theme.colors.link.text};
    }
`;